import React, { useEffect, useRef } from 'react';
import WebDesignHero from './WebDesignHero/WebDesignHero';
import SelectedWebDesignServices from './SelectedWebDesignServices/SelectedWebDesignServices';
import PortfplioDivider from '../../../../../PortfplioDivider/PortfplioDivider';
import SocialDivider from '../../../../../SocialDivider/SocialDivider';
import Footer from '../../../../../../../Components/Footer/Footer';

const WebDesignLanding = () => {
  const scrollRef = useRef(null)
  useEffect(()=>{
    scrollRef.current.scrollIntoView()
  }
,[])
  return (
    <div className='overflow-hidden'>
      <div ref={scrollRef}></div>
      <WebDesignHero/>
      <SelectedWebDesignServices/>
      <PortfplioDivider/>
      <SocialDivider/>
      <Footer/>
    </div>
  );
}

export default WebDesignLanding;
